module.exports = __webpack_public_path__ + "static/media/dardanelles.7c1ad3be.PNG";